export default function copyToClipboard(txt) {
  const el = document.createElement('textarea');
  el.value = txt;
  el.setAttribute('readonly', '');
  el.style.left = '-9999px';
  el.style.position = 'absolute';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}
